(function exposeRetroMuscleSignup(root, factory) {
  var api = factory();

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  } else if (root) {
    root.RMBlackFriday2026 = api;
  }
})(typeof globalThis !== 'undefined' ? globalThis : this, function createSignupApi() {
  'use strict';

  var CAMPAIGN = 'Q4_BLACK_FRIDAY_2026';
  var SIGNUP_TYPE = 'black_friday_2026';
  var DEFAULT_ENDPOINT = 'https://manage.kmail-lists.com/ajax/subscriptions/subscribe';

  function resolveLocale(isoCode) {
    var raw = String(isoCode || 'en').trim().toLowerCase();
    var prefix = raw.split('-')[0] || 'en';
    var isFrench = prefix === 'fr';

    return {
      prefix: prefix,
      languageGroup: isFrench ? 'FR' : 'ENG',
      uiLanguage: isFrench ? 'fr' : 'en',
      source: isFrench ? 'black-friday-2026-fr' : 'black-friday-2026-eng',
    };
  }

  function normalizePhone(rawPhone) {
    var raw = String(rawPhone == null ? '' : rawPhone).trim();
    var value = raw.replace(/[\s()\-]/g, '');

    if (!value) {
      return { valid: true, value: '', empty: true };
    }

    return {
      valid: /^\+[1-9]\d{7,14}$/.test(value),
      value: value,
      empty: false,
    };
  }

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email);
  }

  function validateSignupInput(input) {
    var values = input || {};
    var email = String(values.email || '').trim();
    var phone = normalizePhone(values.phone);
    var errors = {};

    if (!email) {
      errors.email = 'required';
    } else if (!isValidEmail(email)) {
      errors.email = 'invalid';
    }

    if (phone.empty) {
      errors.phone = 'required';
    } else if (!phone.valid) {
      errors.phone = 'invalid';
    }

    if (String(values.honeypot || '').trim()) {
      errors.honeypot = 'spam';
    }

    return {
      valid: Object.keys(errors).length === 0,
      email: email,
      phone: phone.value,
      errors: errors,
    };
  }

  function readUtmParams(search) {
    var raw = String(search || '').trim();
    var query = raw.indexOf('?') === 0 ? raw.slice(1) : raw;
    var params = new URLSearchParams(query);
    var result = {};
    var sourceKeys = {
      UTM_Source: 'utm_source',
      UTM_Medium: 'utm_medium',
      UTM_Campaign: 'utm_campaign',
      UTM_Content: 'utm_content',
      UTM_Term: 'utm_term',
    };

    Object.keys(sourceKeys).forEach(function (targetKey) {
      var value = params.get(sourceKeys[targetKey]);
      if (value != null && value !== '') {
        result[targetKey] = value;
      }
    });

    return result;
  }

  function contextLocale(context) {
    var values = context || {};
    return String(values.storefrontLocale || values.locale || values.isoCode || 'en');
  }

  function readRootConfig(root) {
    var data = root && root.dataset ? root.dataset : {};
    var jsonConfig = {};
    var configNode = root && typeof root.querySelector === 'function'
      ? root.querySelector('[data-rm-bf-2026-config]')
      : null;

    if (configNode && configNode.textContent) {
      try {
        jsonConfig = JSON.parse(configNode.textContent);
      } catch (_parseError) {
        jsonConfig = {};
      }
    }

    var values = Object.assign({}, jsonConfig, data);
    var storefrontLocale = valueOrEmpty(values.storefrontLocale || values.locale || 'en');
    var resolved = resolveLocale(storefrontLocale);

    return {
      listId: valueOrEmpty(values.listId || values.klaviyoListId),
      endpoint: valueOrEmpty(values.endpoint) || DEFAULT_ENDPOINT,
      source: valueOrEmpty(values.source) || resolved.source,
      languageGroup: valueOrEmpty(values.languageGroup) || resolved.languageGroup,
      uiLanguage: valueOrEmpty(values.uiLanguage) || resolved.uiLanguage,
      timeoutMs: Number(values.timeoutMs || 10000),
      context: {
        storefrontLocale: storefrontLocale,
        country: valueOrEmpty(values.country || values.countryIsoCode),
        market: valueOrEmpty(values.market || values.marketHandle),
        marketId: valueOrEmpty(values.marketId || values.marketID),
        landingPage: valueOrEmpty(values.landingPage || values.path),
        source: valueOrEmpty(values.source) || resolved.source,
      },
    };
  }

  function valueOrEmpty(value) {
    return value == null ? '' : String(value);
  }

  function buildProfileProperties(context, fields) {
    var values = context || {};
    var input = fields || {};
    var locale = contextLocale(values);
    var resolved = resolveLocale(locale);
    var phone = normalizePhone(input.phone);
    var utm = input.utm || {};
    var source = valueOrEmpty(values.source) || resolved.source;
    var country = valueOrEmpty(values.country || values.countryIsoCode);
    var market = valueOrEmpty(values.market || values.marketHandle);
    var marketId = valueOrEmpty(values.marketId || values.marketID);
    var landingPage = valueOrEmpty(values.landingPage || values.path);
    var properties = {
      RM_BF2026_Language: resolved.languageGroup,
      RM_Campaign: CAMPAIGN,
      RM_BF2026_Signup: true,
      Signup_Type: SIGNUP_TYPE,
      Language: resolved.uiLanguage,
      RM_Language: resolved.uiLanguage,
      RM_Country: country,
      RM_Market: market,
      RM_Market_ID: marketId,
      Market_Handle: market,
      Market_ID: marketId,
      RM_Storefront_Locale: locale,
      Source: source,
      RM_Source: source,
      '$source': source,
      Form_Placement: 'hero',
      Landing_Page: landingPage,
      UTM_Source: valueOrEmpty(utm.UTM_Source),
      UTM_Medium: valueOrEmpty(utm.UTM_Medium),
      UTM_Campaign: valueOrEmpty(utm.UTM_Campaign),
      UTM_Content: valueOrEmpty(utm.UTM_Content),
      UTM_Term: valueOrEmpty(utm.UTM_Term),
    };

    if (phone.valid && !phone.empty) {
      properties.Phone = phone.value;
    }

    return properties;
  }

  function buildSubscriptionParams(options) {
    var values = options || {};
    var properties = buildProfileProperties(values.context, {
      phone: values.phone,
      utm: values.utm,
    });
    var params = new URLSearchParams();
    var fieldNames = Object.keys(properties).filter(function (key) {
      return key !== '$source' && properties[key] !== '' && properties[key] != null;
    });

    params.set('g', valueOrEmpty(values.listId));
    params.set('email', valueOrEmpty(values.email));
    params.set('$email', valueOrEmpty(values.email));
    params.set('$source', properties['$source']);
    params.set('$fields', fieldNames.join(','));

    fieldNames.forEach(function (key) {
      params.set(key, String(properties[key]));
    });

    return params;
  }

  function getStatusMessage(language, kind) {
    var messages = {
      en: {
        success: 'Check your inbox and CONFIRM your email to receive Black Friday updates.',
        rate_limited: 'Please wait a moment and try again.',
        network: 'We could not reach the signup service. Please try again.',
        timeout: 'The signup took too long. Please try again.',
        rejected: 'We could not complete your signup. Check your details and try again.',
        http_error: 'We could not complete your signup. Please try again.',
      },
      fr: {
        success: 'Vérifie ta boîte mail et clique sur CONFIRM pour recevoir les actus Black Friday.',
        rate_limited: 'Attends un instant puis réessaie.',
        network: 'Le service d’inscription est inaccessible. Réessaie dans un instant.',
        timeout: 'L’inscription a pris trop de temps. Réessaie dans un instant.',
        rejected: 'Ton inscription n’a pas abouti. Vérifie tes informations puis réessaie.',
        http_error: 'Ton inscription n’a pas abouti. Réessaie dans un instant.',
      },
    };
    var locale = language === 'fr' ? 'fr' : 'en';
    return messages[locale][kind] || messages[locale].http_error;
  }

  async function submitSubscription(options) {
    var values = options || {};
    var fetchImpl = values.fetchImpl || (typeof fetch === 'function' ? fetch : null);
    var endpoint = valueOrEmpty(values.endpoint);
    var payload = values.payload instanceof URLSearchParams
      ? values.payload.toString()
      : valueOrEmpty(values.payload);
    var timeoutMs = Number(values.timeoutMs || 10000);
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var timedOut = false;
    var timer;

    if (!fetchImpl) {
      return { ok: false, kind: 'network' };
    }

    if (controller) {
      timer = setTimeout(function () {
        timedOut = true;
        controller.abort();
      }, timeoutMs);
    }

    try {
      var response = await fetchImpl(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
        },
        body: payload,
        signal: controller ? controller.signal : undefined,
      });
      var data = null;

      try {
        data = await response.json();
      } catch (_jsonError) {
        data = null;
      }

      if (response.status === 429) {
        return { ok: false, kind: 'rate_limited', status: 429, data: data };
      }

      if (!response.ok) {
        return { ok: false, kind: 'http_error', status: response.status, data: data };
      }

      if (!data || data.success !== true) {
        return { ok: false, kind: 'rejected', status: response.status, data: data };
      }

      return { ok: true, kind: 'success', status: response.status, data: data };
    } catch (error) {
      if (timedOut || (error && error.name === 'AbortError')) {
        return { ok: false, kind: 'timeout' };
      }
      return { ok: false, kind: 'network' };
    } finally {
      if (timer) {
        clearTimeout(timer);
      }
    }
  }

  function createSubmissionGate() {
    var pending = false;

    return {
      isPending: function () {
        return pending;
      },
      run: async function (work) {
        if (pending) {
          return { ok: false, kind: 'in_flight' };
        }
        pending = true;
        try {
          return await work();
        } finally {
          pending = false;
        }
      },
    };
  }

  return {
    resolveLocale: resolveLocale,
    normalizePhone: normalizePhone,
    validateSignupInput: validateSignupInput,
    readUtmParams: readUtmParams,
    buildProfileProperties: buildProfileProperties,
    buildSubscriptionParams: buildSubscriptionParams,
    submitSubscription: submitSubscription,
    getStatusMessage: getStatusMessage,
    createSubmissionGate: createSubmissionGate,
    readRootConfig: readRootConfig,
  };
});
